import React from 'react';
import VerdonAsciiArt from './components/VerdonAsciiArt';
import './App.css';

function App() {
  return (
    <div className="App">
      <VerdonAsciiArt />
    </div>
  );
}

export default App;